// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from 'react';
import { OANDA_SYMBOL_PREFIX, ICE_SYMBOL_PREFIX, METAL_CODE, CURRENCY_CODE } from '../CONSTANTS';

const getSymbol = (metal = METAL_CODE.XAU, currency = CURRENCY_CODE.GBP) => {
  if (metal === METAL_CODE.XAU || metal === METAL_CODE.XAG) {
    return `${OANDA_SYMBOL_PREFIX}${metal}${currency}`;
  } else if (metal === METAL_CODE.XPD || metal === METAL_CODE.XPT) {
    if (currency === CURRENCY_CODE.USD) {
      return `${OANDA_SYMBOL_PREFIX}${metal}${currency}`;
    } else {
      return `${ICE_SYMBOL_PREFIX}${metal}${currency}`;
    }  
  }
  return `${OANDA_SYMBOL_PREFIX}${metal}${currency}`;
}

function TradingViewWidget({chartType, currency, metal, theme = 'light'}) {
  console.log(chartType, currency, metal)
  const container = useRef();
  const chartTypeValue = chartType === 'candles' ? "1" : "2";
  const symbol = getSymbol(metal, currency);
  console.log(symbol)
  useEffect(
    () => {
      const script = document.createElement("script");
      
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "allow_symbol_change": false,
          "calendar": false,
          "details": false,
          "hide_side_toolbar": true,
          "hide_top_toolbar": false,
          "hide_legend": true,
          "hide_volume": true,
          "hotlist": false,
          "interval": "D",
          "locale": "en",
          "save_image": false,
          "style": "${chartTypeValue}",
          "symbol": "${symbol}",
          "theme": "${theme}",
          "timezone": "Europe/London",
          "backgroundColor": "#ffffff",
          "gridColor": "rgba(46, 46, 46, 0.06)",
          "watchlist": [],
          "withdateranges": true,
          "compareSymbols": [],
          "studies": [],
          "autosize": true
        }`;
      container.current.appendChild(script);
    },
    [chartTypeValue, symbol, theme]
  );

  return (
    <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%" }}>
      <div className="tradingview-widget-container__widget" style={{ height: "calc(100% - 32px)", width: "100%" }}></div>
      <div className="tradingview-widget-copyright"><a href={`https://www.tradingview.com/symbols/${symbol.replace(':', '-')}/`} rel="noopener nofollow noreferrer" target="_blank"><span className="blue-text">{`${metal}${currency} chart`}</span></a><span className="trademark"> by TradingView</span></div>
    </div>
  );
}

export default memo(TradingViewWidget);
